(() => {
  if (customElements.get('delulu-sticky-atc')) return;

  class DeluluStickyAtc extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.form = document.getElementById(this.formId);
      if (!this.form) return;

      this.priceEl = this.querySelector('[data-delulu-sticky-price]');
      this.submitEl = this.querySelector('[data-delulu-sticky-submit]');
      this.infoEl = this.form.closest('.product__info-container') || this.form;

      this.syncFromForm();

      // Single source of truth: the main product form.
      this.form.addEventListener('change', () => this.syncFromForm());
      document.addEventListener('variant:change', (event) => {
        if (event?.detail?.sectionId === this.dataset.sectionId) this.syncFromForm();
      });

      const buyBox = this.form.querySelector('[name="add"]');
      if ('IntersectionObserver' in window && buyBox) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const pastBuyBox = entry.boundingClientRect.top < 0;
              const show = !entry.isIntersecting && pastBuyBox;
              this.toggle(show);
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(buyBox);
      }
    }

    syncFromForm() {
      // Price: mirror what Dawn already rendered for the selected variant.
      if (this.priceEl) {
        const regular = this.priceEl.querySelector('.delulu-sticky-atc__price-regular');
        const compare = this.priceEl.querySelector('.delulu-sticky-atc__price-compare');
        const liveRegular = this.infoEl.querySelector('.price-item--regular, .price .price-item');
        const liveCompare = this.infoEl.querySelector('.price-item--sale, s.price-item--regular');
        if (regular && liveRegular) regular.textContent = liveRegular.textContent.trim();
        if (compare) {
          if (liveCompare && liveCompare.textContent.trim() !== '') {
            compare.textContent = liveCompare.textContent.trim();
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        }
      }
      // Availability + label: mirror the main form's submit button (Dawn owns variant logic).
      if (this.submitEl) {
        const mainSubmit = this.form.querySelector('[name="add"]');
        if (mainSubmit) {
          this.submitEl.disabled = mainSubmit.disabled;
          const label = this.submitEl.querySelector('span');
          const mainLabel = mainSubmit.querySelector('span') || mainSubmit;
          if (label && mainLabel) label.textContent = mainLabel.textContent.trim();
        }
      }
    }

    toggle(show) {
      if (show) {
        this.hidden = false;
        document.body.classList.add('has-delulu-sticky-atc');
      } else {
        this.hidden = true;
        document.body.classList.remove('has-delulu-sticky-atc');
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.body.classList.remove('has-delulu-sticky-atc');
    }
  }

  customElements.define('delulu-sticky-atc', DeluluStickyAtc);
})();
